import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import helper from '../../../../helper';
import RetryWorker from '../../../../common/utils/RetryWorker';
import DateNoTz from '../../../../common/utils/DateNoTz';
import ServicePrices from '../../../../common/utils/ServicePrices';
import ErrorHandle from '../../../../common/utils/ErrorHandle';

export default {
	/*
        Stry: P2US416
        Date: 2020-11-18
        Auth: Franco Mapua
        Desc: New Work Order submission
      */
    submitWorkOrderForm({ commit, state }, bpointData = null) {
        $('#pageLoadingModal').modal('show');
        var searchParams = helper.getSearchParameters();
        var bookingSubmission = state.bookingSubmission || {};
        var form = bookingSubmission.form || {};
        form.bpoint = bpointData;
        form.formId = (searchParams['id'] !== undefined && searchParams['id'] !== null) ? searchParams['id'] : '';

        axios.post(process.env.MIX_API_URL + 'work-order-v2', form)
            .then(response => {
                // Fixed: Create copy of `request` prop, default browser behavior overrides the `request` value.
                response.data.data.requestCopy = (response.data && response.data.data && response.data.data.request) || {};

                return new ResponseDataExtractor(response).data;
            })
            .then(response => {
                if (response.status === 200) {
                    // --- Report the Booking Results
                    var bookings = response.bookings || {}
                    commit('SET_CRN', bookings);
                    commit('SET_BOOKING_COMPLETED_DETAILS', response);
                }
                commit('SET_PAGE', { loading: false });
                $('#pageLoadingModal').modal('hide');
                commit('SET_BOOKING_SUBMISSION', {
                    loading: false,
                    error: false,
                    submitted: true,
                    form: {
                        isQueueBooking: response.isQueueBooking || false,
                        queueBookingMessage: response.queueBookingMessage + '<p class="text-center"><strong>CRN ' + bookings[0].CRN + '<strong></p>' || ''
                    }
                });
            })
            .catch(e => {
                commit('SET_PAGE', { loading: false });
                const { statusCode, error } = new ErrorHandle(e).format;
                if(statusCode == 408) {
                    axios.post(process.env.MIX_API_URL +  'send-failed-api-response-email', {
                        'request_uri': 'work-order-v2'
                    });
                }

                $('#pageLoadingModal').modal('hide');
                commit('SET_BOOKING_SUBMISSION', { loading: false, error: error || 'Error in work order submission', statusCode, paymentBody: bpointData });
                
                if(bpointData) {
                    bpointData.referenceNumber = form.crn
                    commit('SET_PAYMENT_INFO', { valid: false });
                }
            });
    },
	setSubmission({ commit }, data) {
        commit('SET_BOOKING_SUBMISSION', data);
    },
	getDefaultData({ commit}, data) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/get-default-gst')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => commit('SET_GST_DEFAULT_DATA', data))
            .catch(() => console.log('Error when get default data from api'));
    },
    bookingSummaryDetails({ commit }, data) {
        commit('SET_BOOKING_SUMMARY_DETAILS', data);
    },
    /************************Methods for Multiple Service Booking****************************/
    setActiveMultipleServiceSelectedBookingProducts({ state, commit, getters, dispatch }, { data, adding, isInputModel, isInputModelType, isSpinnerModel, isParent, isParentInputModelType }) {
        if (!getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;

        const allProducts = state.activeMultipleServiceSelectedBookingProducts;

        const productsOfOtherServiceGroups = allProducts.filter(product => product.service_group_id !== state.activeServiceGroup.service_group_id);

        const productsOfCurrentServiceGroup = allProducts.filter(product => product.service_group_id === state.activeServiceGroup.service_group_id);

        const productsOfOtherService = productsOfCurrentServiceGroup.filter(product => product.service_setting_id !== state.activeServiceSetting.service_setting_id);

        const productsOfCurrentService = productsOfCurrentServiceGroup.filter(product => product.service_setting_id === state.activeServiceSetting.service_setting_id);

        let remainedProductsOfCurrentService = [];

        if (!adding) {
            if (data.woi_item_type_id) {
                remainedProductsOfCurrentService = productsOfCurrentService.filter(product =>
                                    product.waste_stream_setting_id !== data.waste_stream_setting_id
                                    && product.woi_waste_type_id !== data.woi_waste_type_id
                                    && product.woi_item_type_id !== data.woi_item_type_id);
            } else if (!data.woi_item_type_id && data.woi_waste_type_id) {
                // Woi Waste Type Level
                // Woi Waste Type is spinner? I don't think will occur but let's put this in case it is
                if (isSpinnerModel) {
                    // Save other selected Waste Stream under same Service & Service Group
                    remainedProductsOfCurrentService = productsOfCurrentService.filter(product => product.waste_stream_setting_id !== data.waste_stream_setting_id);

                    // Other selected woi waste type under same Waste Stream will be retained
                    let remainedProductsOfCurrentWasteStream = productsOfCurrentService.filter(product =>
                                    product.waste_stream_setting_id === data.waste_stream_setting_id
                                    && product.woi_waste_type_id !== data.woi_waste_type_id);

                    remainedProductsOfCurrentService = [...remainedProductsOfCurrentService, ...remainedProductsOfCurrentWasteStream];
                }
            } else if (data.waste_variation_id) {
                // Variation Level
                if (isSpinnerModel) {
                    // Save other selected Waste Stream under same Service & Service Group
                    remainedProductsOfCurrentService = productsOfCurrentService.filter(product => product.waste_stream_setting_id !== data.waste_stream_setting_id);
                    
                    // Other selected variations under same Waste Stream will be retained
                    let remainedProductsOfCurrentWasteStream = productsOfCurrentService.filter(product =>
                                    product.waste_stream_setting_id === data.waste_stream_setting_id
                                    && product.waste_variation_id !== data.waste_variation_id);

                    remainedProductsOfCurrentService = [...remainedProductsOfCurrentService, ...remainedProductsOfCurrentWasteStream];
                } else {
                    if (isInputModelType === 'radio') {
                        // Save other selected Waste Stream under same Service & Service Group
                        remainedProductsOfCurrentService = [
                            ...productsOfCurrentService.filter(product => product.waste_stream_setting_id !== data.waste_stream_setting_id)
                        ];
                    }
                }
            } 
            else if(data.fake_stream_id) {
                remainedProductsOfCurrentService = productsOfCurrentService.filter(product => product.option_id !== data.fake_stream_id);
            } else {
                // Waste Stream level
                if (isInputModel) {
                    if (isInputModelType === 'checkbox') {
                        // Other selected waste streams under same Service & Service Group will be retained
                        remainedProductsOfCurrentService = productsOfCurrentService.filter(product => product.waste_stream_setting_id !== data.waste_stream_setting_id);

                        /**
                         * 2021-05-05
                         * BAUM-325
                         * Author: Joseph
                         * Desc: In multiservice, remove fake stream if dependency waste is removed
                         */
                        const portalName                    = helper.getPortalName();
                        const portalServices                = helper.FakeStreams[portalName];
                        const portalServiceFakeWasteStream  = (portalServices && portalServices[state.activeServiceSetting.service_name]) || null;

                        if (portalServiceFakeWasteStream) 
                            {
                            const dependencyWasteName           = portalServiceFakeWasteStream.dependencyName.toLowerCase();

                            remainedProductsOfCurrentService    = remainedProductsOfCurrentService.filter(product => !(product.option_id.indexOf('wastefake') > -1
                                                                    && product.apiValue === portalServiceFakeWasteStream.fakeStream.api_value
                                                                    && data.name.displayName.toLowerCase() === dependencyWasteName) );
                            }
                    }
                }
            }

            commit('SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS',
                [
                    ...productsOfOtherServiceGroups,
                    ...productsOfOtherService,
                    ...remainedProductsOfCurrentService
                ]
            );

            if (remainedProductsOfCurrentService.length === 0) {
                //If no products remained in service. Clear the period.
                dispatch('setActiveMultipleServiceSelectedBookingPeriods', { selectedPeriod: null });
            }

            return;
        }
        // END IF

        if (isParent || data.qty < 1) {
            // If selected is a parent, stop here coz the real product selection is the children not parents
            return;
        }

        const productObject = {
            service_group_id: state.activeServiceGroup.service_group_id,
            service_setting_id: state.activeServiceSetting.service_setting_id,
            waste_stream_setting_id: data.waste_stream_setting_id,
            waste_variation_id: data.waste_variation_id,
            woi_waste_type_id: data.woi_waste_type_id,
            woi_item_type_id: data.woi_item_type_id,
            qty: data.qty,
            price: data.price,
            name: data.name,
            isPaid: data.isPaid,
            isParent,
            option_id: data.option_id, // --- For comparison
            max_per_collection: data.max_per_collection,
            uom: data.uom,
            apiValue: data.apiValue,
            wasteComboApiValue: data.wasteComboApiValue,
            isMultipleSelection: data.isMultipleSelection
        };

        if (data.woi_item_type_id) {
            // Woi Item Type Level
        } else if (!data.woi_item_type_id && data.woi_waste_type_id) {
            // Woi Waste Type Level
            if (isInputModel) {
                if (isInputModelType === 'radio') {
                    if (isParentInputModelType === 'checkbox') {
                        // Retain other Waste Streams only. Clearing all selected woi waste type under this Waste Stream.
                        remainedProductsOfCurrentService = productsOfCurrentService.filter(product =>
                                                            product.waste_stream_setting_id !== data.waste_stream_setting_id);
                    } else {
                        remainedProductsOfCurrentService = [];
                    }
                }
            } else if (isSpinnerModel) {
                // Retain other selected Waste Streams under same Service & Service Group.
                remainedProductsOfCurrentService = productsOfCurrentService.filter(product =>
                                                            product.waste_stream_setting_id !== data.waste_stream_setting_id);

                // Other selected woi waste types under same Waste Stream will be retained.
                let remainedProductsOfCurrentWasteStream = productsOfCurrentService.filter(product =>
                                                            product.waste_stream_setting_id === data.waste_stream_setting_id
                                                            && product.woi_waste_type_id !== data.woi_waste_type_id);

                remainedProductsOfCurrentService = [...remainedProductsOfCurrentService, ...remainedProductsOfCurrentWasteStream];
            }
        } else if (data.waste_variation_id) {
            // Variation Level
            if (isInputModel) {
                if (isInputModelType === 'radio') {
                    // Retain other Waste Streams only. Clearing all selected variations under this Waste Stream.
                    remainedProductsOfCurrentService = productsOfCurrentService.filter(product =>
                                                            product.waste_stream_setting_id !== data.waste_stream_setting_id);
                }
            } else if (isSpinnerModel) {
                // Retain other selected Waste Streams under same Service & Service Group.
                remainedProductsOfCurrentService = productsOfCurrentService.filter(product =>
                                                            product.waste_stream_setting_id !== data.waste_stream_setting_id);

                // Other selected variations under same Waste Stream will be retained.
                let remainedProductsOfCurrentWasteStream = productsOfCurrentService.filter(product =>
                                                            product.waste_stream_setting_id === data.waste_stream_setting_id
                                                            && product.waste_variation_id !== data.waste_variation_id);

                remainedProductsOfCurrentService = [...remainedProductsOfCurrentService, ...remainedProductsOfCurrentWasteStream];
            }
        } else {
            // Waste Stream level
            if (isInputModel && !isSpinnerModel) {
                if (isInputModelType === 'radio') {
                    // Remove all waste stream under same Service & Service Group.
                    remainedProductsOfCurrentService = [];
                } else {
                    // Probably checkbox. Retain all previously selected waste stream under same Service & Service Group.
                    remainedProductsOfCurrentService = productsOfCurrentService;
                }
            } else if (isInputModel && isSpinnerModel) {
                    // Probably checkbox. Retain all previously selected waste stream under same Service & Service Group.
                    // Remove the same waste stream that might added first via checkbox
                    remainedProductsOfCurrentService = isInputModelType === 'checkbox' ?
                                                        productsOfCurrentService.filter(product =>
                                                            product.waste_stream_setting_id !== data.waste_stream_setting_id)
                                                        : [];
            }
        }

        commit('SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS',
            [
                ...productsOfOtherServiceGroups,
                ...productsOfOtherService,
                ...remainedProductsOfCurrentService,
                productObject
            ]
        );
    },
    removeActiveMultipleServiceSelectedBookingProducts({ state, commit, getters, dispatch }, productDetails) {
        if (!getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;

        const service_group_id = productDetails.service_group_id;
        const service_setting_id = productDetails.service_setting_id;

        const allProducts = state.activeMultipleServiceSelectedBookingProducts;

        const foundIndex = allProducts.findIndex(product =>
                product.service_group_id === service_group_id
                && product.service_setting_id === service_setting_id
                && product.waste_stream_setting_id == productDetails.waste_stream_setting_id
                && product.woi_waste_type_id == productDetails.woi_waste_type_id
                && product.waste_variation_id == productDetails.waste_variation_id);

        if (foundIndex > -1) {
            allProducts.splice(foundIndex, 1);
            const productsFromSameServiceOfRemoved = allProducts.filter(product => product.service_group_id === service_group_id && product.service_setting_id === service_setting_id);
            if (productsFromSameServiceOfRemoved.length === 0) {
                dispatch('removeFromMultipleBookingStore', {
                    storeName: 'activeMultipleServiceSelectedBookingDates',
                    service_group_id,
                    service_setting_id,
                    actionName: 'SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES'
                });
                dispatch('removeFromMultipleBookingStore', {
                    storeName: 'activeMultipleServiceOtherBookingState',
                    service_group_id,
                    service_setting_id,
                    actionName: 'SET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE'
                });
            }
        }

        commit('SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS', allProducts);
    },
    setActiveMultipleServiceSelectedBookingPeriods({ state, commit, getters }, periodObject) {
        if (!getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;

        const service_group_id = state.activeServiceGroup.service_group_id;

        const service_setting_id = state.activeServiceSetting.service_setting_id;

        if (!service_group_id || !service_setting_id || !periodObject.hasOwnProperty('selectedPeriod') ) {
            // Either service group, service setting, or period didn't exist. Cancel this action
            return;
        }

        const allPeriods = state.activeMultipleServiceSelectedBookingDates;

        // Keep other service group periods
        const periodOfOtherServiceGroups = allPeriods.filter(period => period.service_group_id !== service_group_id);

        // Get current service group periods
        const periodOfCurrentServiceGroup = allPeriods.filter(period => period.service_group_id === service_group_id);

        // From current service group periods, get other service's periods only
        const periodOfOtherService = periodOfCurrentServiceGroup.filter(period => period.service_setting_id !== service_setting_id);

        
        // Set Period of selected service to empty everytime
        let remainedPeriodsOfCurrentService = [];
        if (periodObject.selectedPeriod) {
            // Add new that will replace previous value.
            remainedPeriodsOfCurrentService = [{ ...periodObject, service_group_id, service_setting_id }];
        }

        let newPeriods = [
            ...periodOfOtherServiceGroups,
            ...periodOfOtherService,
            ...remainedPeriodsOfCurrentService
        ];

        commit('SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES', newPeriods);
    },
    setActiveMultipleServiceBookingSetting({ commit }) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/general-booking')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if (data && data.list.length > 0) {
                    commit('SET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING', data.list[0]);
                }
            })
            .catch(() => console.log('Error when get general booking data from api'));
    },
    clearActiveMultipleServiceGroupSelectedBooking({ state, commit, getters }) {
        if (!getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;

        const productsOfOtherServiceGroups = state.activeMultipleServiceSelectedBookingProducts
            .filter(product => product.service_group_id !== state.activeServiceGroup.service_group_id);

        const periodOfOtherServiceGroups = state.activeMultipleServiceSelectedBookingDates
            .filter(period => period.service_group_id !== state.activeServiceGroup.service_group_id);

        commit('SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS', productsOfOtherServiceGroups);
        commit('SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES', periodOfOtherServiceGroups);
    },
    clearActiveMultipleServiceGroupSelectedBookingByService({ state, commit, getters, dispatch }, { service_group_id, service_setting_id }) {
        if (!getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;

        /******************For Booking Products******************/
        const allProducts = state.activeMultipleServiceSelectedBookingProducts;

        const productsOfOtherServiceGroups = allProducts.filter(product => product.service_group_id !== service_group_id);

        const productsOfCurrentServiceGroup = allProducts.filter(product => product.service_group_id === service_group_id);

        const productsOfOtherService = productsOfCurrentServiceGroup.filter(product => product.service_setting_id !== service_setting_id);

        let newProducts = productsOfOtherServiceGroups;
        if (service_group_id && service_setting_id) {
            newProducts = [...newProducts, ...productsOfOtherService];
        }
        
        /******************For Booking Periods******************/
        const allPeriods = state.activeMultipleServiceSelectedBookingDates;

        // Keep other service group periods
        const periodOfOtherServiceGroups = allPeriods.filter(period => period.service_group_id !== service_group_id);

        // From current service group periods, get other service's periods only
        const periodOfCurrentServiceGroup = allPeriods.filter(period => period.service_group_id === service_group_id);

        // From current service group periods, get other service's periods only
        const periodOfOtherService = periodOfCurrentServiceGroup.filter(period => period.service_setting_id !== service_setting_id);

        let newPeriods = periodOfOtherServiceGroups;
        if (service_group_id && service_setting_id) {
            newPeriods = [...newPeriods, ...periodOfOtherService];
        }

        commit('SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS', newProducts);
        commit('SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES', newPeriods);

        if (service_group_id && !service_setting_id) {
            dispatch('removeFromMultipleBookingStore', {
                storeName: 'activeMultipleServiceOtherBookingState', // Booking State is per Group & Service
                service_group_id,
                service_setting_id: undefined,
                actionName: 'SET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE'
            });

            dispatch('removeFromMultipleBookingStore', {
                storeName: 'activeMultipleServiceEntitlementSummaries', // Summaries is per Group
                service_group_id,
                service_setting_id: undefined,
                actionName: 'SET_ACTIVE_MULTIPLE_SERVICE_ENTITLEMENT_SUMMARIES'
            });

            dispatch('removeFromMultipleBookingStore', {
                storeName: 'activeMultipleServiceAcceptedBookingTerms', // Terms is per Group
                service_group_id,
                service_setting_id: undefined,
                actionName: 'SET_ACTIVE_MULTIPLE_SERVICE_ACCEPTED_BOOKING_TERMS'
            });
        } else if (service_group_id && service_setting_id) {
            dispatch('removeFromMultipleBookingStore', {
                storeName: 'activeMultipleServiceOtherBookingState', // Booking State is per Group & Service
                service_group_id,
                service_setting_id,
                actionName: 'SET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE'
            });
        }
    },
    setActiveMultipleServiceBookingTerms({ state, commit, getters }, body) {
        if (!getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;

        const service_group_id = state.activeServiceGroup.service_group_id;
        const allAcceptedTerms = state.activeMultipleServiceAcceptedBookingTerms;

        // Keep other service group periods
        const acceptedTermsOfOtherServiceGroups = allAcceptedTerms.filter(detail => detail.service_group_id !== service_group_id);

        let newAcceptedTerms = [
            ...acceptedTermsOfOtherServiceGroups,
            {
                service_group_id,
                ...body
            }
        ];
        commit('SET_ACTIVE_MULTIPLE_SERVICE_ACCEPTED_BOOKING_TERMS', newAcceptedTerms);
    },
	setActiveMultipleServiceEntitlementSummaries({ state, commit, getters }, body) {
        if (!getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;

        const service_group_id = state.activeServiceGroup.service_group_id;
        const allEntitlementSummaries = state.activeMultipleServiceEntitlementSummaries;

        // Keep other service group entitlement summaries
        const entitlementSummariesOfOtherServiceGroups = allEntitlementSummaries.filter(detail => detail.service_group_id !== service_group_id);

        let list = [
            ...entitlementSummariesOfOtherServiceGroups,
            {
                service_group_id,
                ...body
            }
        ];
        commit('SET_ACTIVE_MULTIPLE_SERVICE_ENTITLEMENT_SUMMARIES', list);
    },
    setActiveMultipleServiceOtherBookingState({ state, commit, getters }, body = {}) {
        if (!getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;

        const service_group_id = getters.GET_ACTIVE_SERVICE_GROUP.service_group_id;
        const service_setting_id = getters.GET_ACTIVE_SERVICE_SETTING.service_setting_id;

        const allBookingState = state.activeMultipleServiceOtherBookingState;

        const bookingStateOfOtherServiceGroups = allBookingState.filter(booking => booking.service_group_id !== service_group_id);

        const bookingStateOfCurrentServiceGroup = allBookingState.filter(booking => booking.service_group_id === service_group_id);

        const bookingStateOfOtherService = bookingStateOfCurrentServiceGroup.filter(booking => booking.service_setting_id !== service_setting_id);

        const bookingStateOfCurrentService = bookingStateOfCurrentServiceGroup.find(booking => booking.service_setting_id === service_setting_id);

        let oldBookingStateOfCurrentService = { service_group_id, service_setting_id };
        
        if (bookingStateOfCurrentService) {
            oldBookingStateOfCurrentService = bookingStateOfCurrentService;
        }

        let newBookingStates = [
            ...bookingStateOfOtherServiceGroups,
            ...bookingStateOfOtherService,
            {
                ...oldBookingStateOfCurrentService,
                ...body
            }
        ];

        commit('SET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE', newBookingStates);
    },
    removeFromMultipleBookingStore({ state, commit }, { storeName, service_group_id, service_setting_id, actionName }) {
        const flatList = state[storeName];
        let foundIndexToRemove = [];
        if (service_group_id && service_setting_id) {
            foundIndexToRemove = flatList.map((item, i) => item.service_group_id === service_group_id && item.service_setting_id === service_setting_id ? i : '').filter(String);
        } else if (service_group_id && !service_setting_id) {
            foundIndexToRemove = flatList.map((item, i) => item.service_group_id === service_group_id ? i : '').filter(String);
        }

        if (foundIndexToRemove.length > 0) {
            const newFlat = [...flatList.filter((item, i) => foundIndexToRemove.indexOf(i) === -1 )];
            commit(actionName, newFlat);
        }
    },
    /**
    * Story:  RP-128
    * Author: Joseph
    * Desc:   In Brim, when a waste is selected and has dependency that waste wouldn't be selected BUT still added to cart.
    *         By the time you select any waste without waste dependency the calendar wont enable (it should) bcoz a faulty
    *         waste is added to cart with -1 quantity (the waste with dependency).
    *         Fix is to remove the waste from cart once propmted to have waste dependency
    */
    removeDependentWasteStream({ state, commit }, unwantedSelectedProducts) {
	    const unwantedOptionIds = unwantedSelectedProducts;
	    const selectedBookingProducts = state.bookingState.selectedBookingProducts.filter(sBP => unwantedOptionIds.indexOf(sBP.option_id) < 0 );
	    commit('SET_BOOKING_STATE', { selectedBookingProducts });
	    commit('SET_BOOKING_PRODUCTS', selectedBookingProducts);
    },
    getServiceGroup({commit}) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/service-group')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => commit('SET_SERVICE_GROUP', data))
            .catch(() => console.log('Error when get service group data from api'));
    },
    getAddressSetting({commit}) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/address-setting')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => commit('SET_SERVICE_GROUP_ADDRESS', data))
            .catch(() => console.log('Error when get address setting from api'));
    },
    getServices({ commit}) {
        commit('SET_SERVICES', {
            fetched: false,
            data: {
                list : []
            }
        });
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/service-setting', {})
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                data.fetched = true;
                commit('SET_SERVICES', data);
            })
            .catch(() => console.log('Error when get services from api'));
    },
    getExcludedServicesOfAddressSetting({ commit }, addressId) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/fetch-service-address', {
            params : {
                address_setting_id : addressId
            }
        })
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                var idArray = [];
                if(data && data.list){
                    data.list.forEach(pivotRow =>{
                        idArray.push(pivotRow.service_setting.service_setting_id);
                    })
                }
                commit('SET_EXCLUDED_SERVICES_OF_SELECTED_ADDRESS_SETTING', {
                    list: idArray
                });
            })
            .catch(() => console.log('Error when get service\' address from api'));
        
    },
    getTermsCondition({ commit }) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/terms-and-condition')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => commit('SET_TERMS_CONDITION', data))
            .catch(() => console.log('Error when get term data from api'));
    },
    getEntitlementGroup({ commit }) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/entitlement-setting')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => commit('SET_ENTITLEMENT_GROUP', data))
            .catch(() => console.log('Error when get entitlement data from api'));
    },
    getGSTData({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.MIX_API_URL + 'cms/pricing-setting/gst-setting')
                .then(response => new ResponseDataExtractor(response).data)
                .then(data => {
                    commit('SET_GST_DATA', data);
                    resolve(data);
                })
                .catch(() => console.log('Error when get gst data from api'));
            });
    },
    getServicesOfSelectedServiceGroup({ commit }) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/service-setting')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => commit('SET_SERVICES_OF_SELECTED_SERVICE_GROUP', data))
            .catch(() => console.log('Error when get service setting from api'));
    },
    getWasteStreams({ commit, state, dispatch }, serviceSettingId, limit = 100) {
        commit('SET_WASTE_STREAM', { loading: true, fetched: false, list: [], error: '' });
        
        if(state.bookingState.selectedService){
            axios.get(process.env.MIX_API_URL + 'cms/booking-setting/get-waste-stream-by-service-id/' + state.bookingState.selectedService.service_setting_id,{
                params: {
                    limit : 100
                }
            })
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                // Determine waste stream to display base on user type (resident or cso)
                let list = helper.UserType[state.personalInfo.type] === helper.UserType.resident ?
                data.list.filter(l => l.is_res === helper.Option.On) :
                data.list.filter(l => l.is_cso === helper.Option.On);

                if (state.bookingState.activeAddress.websiteAction) {
                    // Get address setting for current active address
                    const addressSetting = state.serviceGroupAddress.list.find(stream => stream.website_action === `${state.bookingState.activeAddress.websiteAction}`);

                    if(addressSetting){
                        list = list.filter(stream => !addressSetting.waste_stream.some(excludedStream => excludedStream.waste_stream_setting_id === stream.waste_stream_setting_id));
                    }
                    // Filter waste streams that part of excluded waste streams of address setting
                    
                }

                list.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
                list = list.map(l => {
                    if (l.max_per_collection === null) {
                        l.max_per_collection =100;
                    }
                    return l;
                });

                commit('SET_WASTE_STREAM', { list });

                // If Waste Streams Settings available, it make sense to load the Waste Stream options 
                if (list.length > 0) {
                    // Whether Free or Paid Service Setting, always load Variation
                    dispatch('getWasteVariation', { wasteStreamSettings: list, willLoadWoiWaste: state.activeServiceSetting.is_paid === helper.Payment.Free });

                    // if (state.activeServiceSetting.is_paid === helper.Payment.Free) {
                    //     // If Free, we also need to load any possible Woi Waste Types! There should be a better way to detect Woi relation on this!
                    //     dispatch('getWoiWasteType', list);
                    // }
                    
                } else {
                    // Finally, finished the Waste Stream loading fetching state
                    commit('SET_WASTE_STREAM', { loading: false, fetched: true });
                }
            })
            .catch(e => {
                commit('SET_WASTE_STREAM', { loading: false, error: helper.errorCatch(e) || 'Error in loading waste stream setting' });
            });
        }
    },
    getAllWasteStreams({ commit }) {
        // Reset State
        commit('SET_ALL_WASTE_STREAMS', {
            list : [],
            error : null
        })
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/get-waste-stream')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                commit('SET_ALL_WASTE_STREAMS', {
                    list : data.list
                })
            })
            .catch(e => {
                commit('SET_ALL_WASTE_STREAMS', {
                    list : [],
                    error : e
                });
            });
    },
    getWasteStreamsOfService({ commit, state}, serviceId) {
        // --- Fix this first
        return axios.get(process.env.MIX_API_URL + `cms/booking-setting/get-waste-stream-by-service-id/${serviceId}`, {
            params: {
                limit : 100
            }
        })
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if(!data){
                    data = {}
                }

                if(Array.isArray(data.list)){
                    let list = data.list

                    // --- Filter By User Type
                    var filterByUserType
                     = null
                    if(helper.UserType[state.personalInfo.type] === helper.UserType.resident){
                        filterByUserType
                         = "is_res"  
                    }
                    else if(helper.UserType[state.personalInfo.type] === helper.UserType.cso){
                        filterByUserType
                         = "is_cso"  
                    }

                    // --- Filter By Address Code
                    var exclusionWasteStream = null
                    var exclusionWoiWasteType = null
                    if (state.bookingState.activeAddress.websiteAction) {
                        // Get address setting for current active address
                        const addressSetting = state.serviceGroupAddress.list.find(stream => stream.website_action === `${state.bookingState.activeAddress.websiteAction}`);

                        if(addressSetting){
                            var exclusionWasteStream = addressSetting.waste_stream
                            var exclusionWoiWasteType = addressSetting.woi_waste_type
                        }
                    }
                    
                    if(exclusionWasteStream){
                        list = list.filter(stream => !exclusionWasteStream.some(excludedStream => excludedStream.waste_stream_setting_id === stream.waste_stream_setting_id))
                    }
                    if(filterByUserType){
                        list = list.filter(l => l[filterByUserType
                        ] === helper.Option.On)

                        // --- Filter out any children that don't pass the filter

                        list.forEach((wasteStream, index, theArray) => {
                            if(Array.isArray(wasteStream.children)){
                                // --- Use a reference to data.list because you can't mutate the cursor in a forEach
                               list[index].children = list[index].children.filter(variation => {
                                    return variation[filterByUserType
                                    ] == undefined || variation[filterByUserType
                                    ] == helper.Option.On
                                })
                            }
                        })
                    }
                    
                    if(exclusionWoiWasteType){
                        list.forEach((wasteStream, index, theArray) => {
                            if(Array.isArray(wasteStream.children)){
                                // --- Use a reference to data.list because you can't mutate the cursor in a forEach
                               list[index].children = list[index].children.filter(variation => {
                                    if(!variation.woi_waste_type_id){
                                        return true
                                    }
                                    else{
                                        return !exclusionWoiWasteType.some(excludedWoiWasteType => excludedWoiWasteType.woi_waste_type_id === variation.woi_waste_type_id)
                                    }
                                })
                            }
                        })
                    }

                    // --- Attach max per collection if it doesn't exit
                    list = list.map(l => {
                        if (l.max_per_collection === null) {
                            l.max_per_collection = 100;
                            l.max_per_collection_defaulted = true
                        }
                        else{
                            l.max_per_collection_defaulted = false
                        }
                        return l;
                    });
                    
                    // --- Order by order
                    list.sort(function(a, b){
                        return a.order - b.order
                    })

                    data.list = list
                }

                return data.list
            })
            .catch(e => console.error('Error when get watse stream by service id from api' , helper.errorCatch(e)));
        // return new Promise((resolve, reject) => {
        //     resolve([
        //             {
        //                 "waste_stream_setting_id": 90,  //first waste from get-waste-stream-by-service-id/46
        //                 "service_setting_id": 46,
        //                 "waste_stream_name": "Bundled green waste (2m3)",
        //                 "additional_info_header": null,
        //                 "additional_info_text": null,
        //                 "is_res": 1,
        //                 "is_cso": 1,
        //                 "variation_selection": 2,
        //                 "multiplier": null,
        //                 "uom": null,
        //                 "max_per_collection": null,
        //                 "order": 1,
        //                 "has_variation": 1, //yes
        //                 "api_value": "General & Mattress",
        //                 "qty_cap": null,
        //                 "price": null, //null because this waste had variations
        //                 "primary_waste_stream_id": 91,  //get-waste-stream-combo-by-service/46
        //                 "secondary_waste_stream_id": 92, //get-waste-stream-combo-by-service/46
        //                 "children":[ //this is the variation from this wastestream = 90 above. return null of we do not have variation
        //                      {
        //                         "variation_name":"king",
        //                         "waste_stream_setting_id":6,
        //                         "waste_variation_id":9,
        //                         "priceSettings ": { //price follow variation 9
        //                             "price1":5,
        //                             "price2":6,
        //                             "enddate ":"2020-07-07",
        //                         }, 
        //                      },
        //                      {
        //                         "variation_name":"queen",
        //                         "waste_stream_setting_id":6,
        //                         "waste_variation_id":7,
        //                         "priceSettings ": { //price follow variation 7
        //                             "price1":9,
        //                             "price2":2,
        //                             "enddate ":"2020-07-07",
        //                         }, 
        //                      },
        //                   ]
        //             },
        //             { 
        //                 "waste_stream_setting_id": 91, //second waste get-waste-stream-by-service-id/46
        //                 "service_setting_id": 46,
        //                 "waste_stream_name": "General waste (2m3)",
        //                 "additional_info_header": null,
        //                 "additional_info_text": null,
        //                 "is_res": 1,
        //                 "is_cso": 1,
        //                 "variation_selection": 2,
        //                 "multiplier": null,
        //                 "uom": null,
        //                 "max_per_collection": null,
        //                 "order": 2,
        //                 "has_variation": 1,
        //                 "api_value": "General & Mattress",
        //                 "qty_cap": null,
        //                 "priceSettings ": { //return price because no variation
        //                     "price1":5,
        //                     "price2":6,
        //                     "enddate ":"2020-07-07",
        //                 }, //from get-product-pricing-by-service-id/46
        //                 "primary_waste_stream_id": 91, //same, because same service.
        //                 "secondary_waste_stream_id": 92
        //             }
        //         ]
        //     )
        // });
        
    },
    getServicePriceSettings(){
        return axios.get(process.env.MIX_API_URL + 'cms/pricing-setting/product-pricing')
            .then(response => new ResponseDataExtractor(response).data)
            .then(response => {
                // Extract the Woi Waste Type objects
                var list = response.list && Array.isArray(response.list) ?  response.list : []
                var servicePriceList = []

                for(let i = 0; i < list.length; i++){
                    if(list[i].product_pricing_service && list[i].product_pricing_service_price){
                        servicePriceList.push({
                            service_setting_id : list[i].product_pricing_service,
                            price : list[i].product_pricing_service_price
                        })
                    }
                }

               return servicePriceList
            })
            .catch(e => console.error('Error when get service pricing from api', helper.errorCatch(e)));

    },
    getAllWoiWasteType({ commit, state, dispatch }) {
        return axios.get(process.env.MIX_API_URL + 'cms/booking-setting/fetch-waste-stream-woi-waste-v2')
            .then(response => new ResponseDataExtractor(response).data)
            .then(response => response.list)
            .catch(e => console.error('Error when get waste stream woi from api', helper.errorCatch(e)));
 
    },
    getWoiWasteType({ commit, state, dispatch }, wasteStreamSettings) {
        commit('SET_WOI_WASTE', { loading: true, fetched: false, list: [], error: '' });

        // Create multiple promises that will be called all at once
        // const promiseCollection = [];
        const waste_stream_setting_id_arr = new Set();
        wasteStreamSettings.forEach(setting => {
            // const promise = axios.get(process.env.MIX_API_URL + 'cms/booking-setting/fetch-waste-stream-woi-waste', {
            //     params: {
            //         waste_stream_setting_id: setting.waste_stream_setting_id
            //     }
            // });
            // promiseCollection.push(promise);
            waste_stream_setting_id_arr.add(setting.waste_stream_setting_id);
        })

        const promise = axios.get(process.env.MIX_API_URL + 'cms/booking-setting/fetch-waste-stream-woi-waste-v2', {
            params: {
                waste_stream_setting_id: JSON.stringify(Array.from(waste_stream_setting_id_arr))
            }
        });

        // Call all promises at once
        // axios.all(promiseCollection)
        promise
            .then(response => new ResponseDataExtractor(response).data)
            .then(response => {
                // Extract the Woi Waste Type objects
                const wasteTypes = [];

                // CSO/Resident Filtering
                response.list = helper.UserType[state.personalInfo.type] === helper.UserType.resident ?
                response.list.filter(l => l.woi_waste_type.is_res === helper.Option.On) :
                response.list.filter(l => l.woi_waste_type.is_cso === helper.Option.On);

                response.list.forEach(dd => {
                    dd.woi_waste_type['waste_stream_setting_id'] = dd.waste_stream_setting.waste_stream_setting_id;
                    wasteTypes.push(dd.woi_waste_type);
                });
                commit('SET_WOI_WASTE', { loading: false, fetched: true, list: wasteTypes });

                dispatch('getWoiItemType', wasteTypes);
            })
            .catch(e => {
                commit('SET_WOI_WASTE', { loading: false, error: helper.errorCatch(e) || 'Error in loading woi wastes and options' });
            });
    },
    getWoiItemType({ commit, state, dispatch }, woiWasteTypes) {
        if (woiWasteTypes.length === 0) {
            dispatch('setWasteStreamAndVariations');
            dispatch('getWasteCombo');
            return;
        }

        commit('SET_WOI_ITEM_TYPE', { loading: true, fetched: false, list: [], error: '' });

        // Create multiple promises that will be called all at once
        // const promiseCollection = [];
        const woi_waste_type_id_arr = new Set();
        woiWasteTypes.forEach(woiWaste => {
            // const promise = axios.get(process.env.MIX_API_URL + 'cms/booking-setting/fetch-woi-waste-woi-item-v2', {
            //     params: {
            //         woi_waste_type_id: woiWaste.woi_waste_type_id
            //     }
            // });
            // promiseCollection.push(promise);
            woi_waste_type_id_arr.add(woiWaste.woi_waste_type_id);
        })
        const promise = axios.get(process.env.MIX_API_URL + 'cms/booking-setting/fetch-woi-waste-woi-item-v2', {
            params: {
                woi_waste_type_id: JSON.stringify(Array.from(woi_waste_type_id_arr))
            }
        });

        // Call all promises at once
        // axios.all(promiseCollection)
        promise
            .then(response => new ResponseDataExtractor(response).data)
            .then(response => {
                // // Extract the Woi Waste Type objects

                // CSO/Resident Filtering
                response.list = helper.UserType[state.personalInfo.type] === helper.UserType.resident ?
                response.list.filter(l => l.woi_waste_type.is_res === helper.Option.On) :
                response.list.filter(l => l.woi_waste_type.is_cso === helper.Option.On);

                const woiItems = [];
                response.list.forEach(dd => {
                    if(!dd.woi_item_type){
                        dd.woi_item_type = {}
                    }
                    
                    if (!woiItems.find(w => w.waste_stream_setting_id === dd.woi_item_type.waste_stream_setting_id
                        && w.woi_waste_type_id === dd.woi_waste_type.woi_waste_type_id
                        && w.woi_item_type_id === dd.woi_item_type.woi_item_type_id)) {
                        dd.woi_item_type['woi_waste_type_id'] = dd.woi_waste_type.woi_waste_type_id;
                        woiItems.push(dd.woi_item_type);
                    }
                });
                commit('SET_WOI_ITEM_TYPE', { loading: false, fetched: true, list: woiItems });

                dispatch('setWasteStreamAndVariations');
                dispatch('getWasteCombo');
            })
            .catch(e => {
                commit('SET_WOI_ITEM_TYPE', { loading: false, error: helper.errorCatch(e) || 'Error in loading woi items and options' });
            });
    },
    setWasteStreamAndVariations({ state, commit }) {
        // Attached Woi Items to their parent Woi Waste
        var newWoiWasteTypes = [...state.woiWasteTypes.list].map(woiWaste => {
            woiWaste['children'] = [...state.woiItemTypes.list].filter(woiItem => woiItem.woi_waste_type_id === woiWaste.woi_waste_type_id && woiItem.waste_stream_setting_id === woiWaste.waste_stream_setting_id) || [];
            return woiWaste;
        });
        
        // Filter WOI based on address setting
        if (state.bookingState.activeAddress.websiteAction) {
            // Get address setting for current active address
            const addressSetting = state.serviceGroupAddress.list.find(stream => stream.website_action === `${state.bookingState.activeAddress.websiteAction}`);
            if(addressSetting && addressSetting.woi_waste_type){
                var excludedWoiWasteIdArr = addressSetting.woi_waste_type.map(woiWaste => woiWaste.woi_waste_type_id)
                newWoiWasteTypes = newWoiWasteTypes.filter(woiWaste => !excludedWoiWasteIdArr.includes(woiWaste.woi_waste_type_id));
            }
        }

        // Attached Woi Waste to their parent Waste Stream
        const list = [...state.wasteStreams.list].map(stream => {
            stream['children'] = [
                ...state.wasteVariation.list.filter(variation => variation.waste_stream_setting_id === stream.waste_stream_setting_id), // Filter variations
                ...[...newWoiWasteTypes].filter(woiWaste => woiWaste.waste_stream_setting_id === stream.waste_stream_setting_id) // Filter woi waste types
            ];
            return stream;
        });

        // Finally, finished the Waste Stream loading fetching state
        commit('SET_WASTE_STREAM', { loading: false, fetched: true, list });
    },
    getWasteVariation({ commit, dispatch }, { wasteStreamSettings, willLoadWoiWaste }) {
        commit('SET_WASTE_VARIATION', { loading: true, fetched: false, list: [], error: '' });

        // Create multiple promises that will be called all at once
        const promiseCollection = [];
        wasteStreamSettings.forEach(setting => {
            if (setting.has_variation === helper.Option.On) {
                const promise = axios.get(process.env.MIX_API_URL + 'cms/booking-setting/get-waste-variation-by-waste-stream/' + setting.waste_stream_setting_id);
                promiseCollection.push(promise);
            }
        })

        // Call all promises at once
        axios.all(promiseCollection)
            .then(response => new ResponseDataExtractor(response).data)
            .then(response => {
                // Extract the Waste Variation objects
                let wasteVariation = [];
                response.forEach(r => {
                    wasteVariation =  [ ...wasteVariation, ...r.data.data ];
                });

                commit('SET_WASTE_VARIATION', { loading: false, fetched: true, list: helper.removeDuplicates(wasteVariation, 'waste_variation_id') });

                dispatch('pricingSetting', willLoadWoiWaste)
            })
            .catch(e => {
                commit('SET_WASTE_VARIATION', { loading: false, error: helper.errorCatch(e) || 'Error in loading waste streams and variation' });
            });
    },
    setActiveServiceGroup({ commit }, data) {
        commit('SET_ACTIVE_SERVICE_GROUP', data);
    },
    setActiveServiceSetting({ commit, state }, service_setting) {
        commit('SET_ACTIVE_SERVICE_SETTING', state.services.list.find(d => d.service_group_id === state.activeServiceGroup.service_group_id
            && d.service_setting_id === service_setting.service_setting_id))
    },
    resetActiveServiceSetting({ commit, data}) {
        commit('SET_ACTIVE_SERVICE_SETTING', data);
    },
    setWasteStream({ commit }) {
        commit('SET_WASTE_STREAM', { loading: false, fetched: false, list: [], error: '' });
    },
    getMultipleCollection({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.MIX_API_URL + 'cms/booking-setting/multiple-collection')
                .then(response => new ResponseDataExtractor(response).data)
                .then(data => {
                    commit('SET_MULTIPLE_COLLECTION', data);
                    resolve(data);
                })
                .catch(() => console.log('Error when get multiple collection from api'));
            });
    },
    getAvailableBookingDatesOfAddress({ commit, dispatch }, addressId = 0){
        window.axios.defaults.headers.common['Authorization'] = localStorage.AuthToken;
        new RetryWorker(4, 500, 
            function() {
                return new Promise((resolve, reject) => {
                    let url = process.env.MIX_API_URL + 'available-booking-dates?id=' + addressId;
                    axios.get(url)
                        .then(response => new ResponseDataExtractor(response).data)
                        .then((response) => {
                            if(!response){
                                commit('SET_SHOW_MODAL_ERROR', {
                                    title: "NULL returned",
                                    message: "There are no dates available for booking."
                                });

                                return;
                            } else {
                                if(response && response.availableBookingDates){
                                    response.list = response.availableBookingDates
                                    response.availableBookingDates = null;
                                }

                                /**
                                 * 
                                 * Debug
                                 * Use this debug to mock a zero available booking credit for a waste date
                                 * 
                                 */
                                if (window.location.href.indexOf('wastetozero') > -1)
                                    {
                                    const params = helper.getSearchParameters()
                                    const otherHardwasteBundledGreenwaste = response.list.map(d => {
                                        if ( params.wastetozero.split(',').indexOf(d.wasteStreams) > -1 ) {
                                            if (d.date === params.datetozero) {
                                                d.availableBookings = 0;
                                            }
                                            if (d.date === params.datetoallow) {
                                                d.availableBookings = 3000;
                                            }
                                        }
                                        return d;
                                    })

                                    response.list = otherHardwasteBundledGreenwaste
                                    }

                                if (window.location.href.indexOf('monthtozero') > -1 || window.location.href.indexOf('yeartozero') > -1) {
                                    const params = helper.getSearchParameters()
                                    response.list = response.list.map(d => {
                                        const m = (params && params.monthtozero) || 'Jun';
                                        const y = (params && params.yeartozero) || '2021';

                                        const ms = m.split(',')

                                        if ( ms.includes((new DateNoTz(d.date)).getMonthDescShort())
                                            && (new DateNoTz(d.date)).getFullYear() === y ) {
                                            d.availableBookings = '0';
                                        }

                                        return d;
                                    });
                                }
                                    
                                commit('SET_AVAILABLE_BOOKING_DATES_OF_ADDRESS', response);
                                resolve(response);
                            }
                        })
                        .catch(e => {
                            const { error } = new ErrorHandle(e).format;
                            if(error === "API Return Null") {
                                commit('SET_SHOW_MODAL_ERROR', {
                                    title: "NULL returned",
                                    message: "There are no dates available for booking."
                                });
                                resolve(e);
                            } else {
                                console.log('Error when get available booking date from api');
                                reject(e);
                            }
                        });
                });
            },
            null,
            function() {
                axios.post(process.env.MIX_API_URL +  'send-failed-api-response-email', {
                    'request_uri': 'available-booking-dates?id=' + addressId
                });
                commit('SET_SHOW_MODAL_RETRY', true);
            },
        ).doWork();
    },
    resetAvailableBookingDatesOfAddress({ commit }){
        commit('SET_AVAILABLE_BOOKING_DATES_OF_ADDRESS', {
            list : []
        });
    },
    getServerDate({ commit }, residentId) {
        return axios.get(process.env.MIX_API_URL + 'utility/server-date-australia')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                /*
                    --- DEBUG DATE CONTROL
                    At the booking details page, add "&datedebug=2021-04-20"
                */
                if(window.location.href.indexOf('datedebug') > -1 ){
                
                    var params = helper.getSearchParameters()
                    var debugDateString 
                    if(params.datedebug){
                        debugDateString = `${params.datedebug}`
                    }
                    if(params.timedebug){
                        debugDateString += ` ${params.timedebug.replaceAll("%3A", ":")}`
                    }
                    else{
                        debugDateString += ` 00:00:00`
                    }
                    if(debugDateString){
                        data.payload = debugDateString
                    }

                }

                commit('SET_SERVER_DATE', data);
                return data
            })
            .catch(e => console.error("Error when get server date setting from api", helper.errorCatch(e)));
    },
    pricingSetting({ commit, dispatch, state }, willLoadWoiWaste) {
        commit('SET_PRICING', { loading: true, fetched: false, list: [], error: '' });
        axios.get(process.env.MIX_API_URL + 'cms/pricing-setting/get-product-pricing-by-service-id/' + state.activeServiceSetting.service_setting_id)
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                // Commit extracted pricings based on service setting selected
                // TODO: Ideally, service setting should be used as GET filter, but incase the filtering wasn't ready yet we would still filter it in Front end
                commit('SET_PRICING', {
                    loading: false,
                    fetched: true,
                    // TODO: Number fields shouldn't be an issue, remove parsing of number base property when B.E is fixed
                    list: data.list.map(d => parseNumberFields(d))
                });

                if (!willLoadWoiWaste) {

                    // Attached Waste Stream Variations to their parent Waste Stream
                    const list = [...state.wasteStreams.list].map(stream => {
                        stream['children'] = [...state.wasteVariation.list].filter(variation => variation.waste_stream_setting_id === stream.waste_stream_setting_id) || [];
                        return stream;
                    });

                    // Finally, finished the Waste Stream loading fetching state
                    commit('SET_WASTE_STREAM', { loading: false, fetched: true, list });
                    dispatch('getWasteCombo');
                } else {
                    dispatch('getWoiWasteType', state.wasteStreams.list);
                }
            })
            .catch(e => {
                commit('SET_PRICING', { loading: false, error: helper.errorCatch(e) || 'Error in loading product pricing' });
            });
    },
    activeFormIndex({ commit }, data) {
        commit('SET_ACTIVEFORM_INDEX', data);
    },
    setBookingProducts({ commit }, data) {
        commit('SET_BOOKING_PRODUCTS', data);
    },
    setBookingState({commit}, data){
        commit('SET_BOOKING_STATE', data);
    },
    resetBookingState({commit, state, getters}){
        for(var key in state.bookingState){
            state.bookingState[key] = null;
        }
        commit('SET_BOOKING_SUMMARY_DETAILS', {
            gstComputed : 0,
            subTotal: 0,
            totalAmount: 0
        });

        commit('SET_BOOKING_PRODUCTS', []);
        commit('SET_BOOKING_STATE', { selectedBookingProducts: [] });
        commit('SET_CRN', null);
        commit('SET_BOOKING_SUBMISSION', { error: '', form: null, paymentBody: null, submitted: false });

        // Reset Multiple service cart if applicable
        if (!getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;
        ['SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS',
        'SET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES',
        'SET_ACTIVE_MULTIPLE_SERVICE_ACCEPTED_BOOKING_TERMS',
        'SET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE',
        'SET_ACTIVE_MULTIPLE_SERVICE_ENTITLEMENT_SUMMARIES']
            .forEach(action => commit(action, []));
        commit('SET_BOOKING_COMPLETED_DETAILS', null);
    },
    resetStepFormIndex({ commit, state}) {
        state.activeStepIndex = 0;
    },
    setTotalSteps({ commit, state }, total) {
        state.totalSteps = total;
    },
    workOrderCheck({ commit, dispatch, state }, next) {
        $('#pageLoadingModal').modal('show');
        commit('SET_PAGE', { loading: true });
        const email = state.personalInfo.email;
        axios.post(process.env.MIX_API_URL + 'get-user', {
            email
        })
        .then(response => new ResponseDataExtractor(response).response)
        .then(response => {
            if (response.status === 200) {
                dispatch(next);
            }
        })
        .catch(e => {
            commit('SET_PAGE', { loading: false });
            commit('SET_PAYMENT_INFO', { 
                loading: false, 
                error: e.toString() || 'The service is currently not available. Please try again later.', 
                valid: false,
            });
            $('#pageLoadingModal').modal('hide');
        });
    },
    submitPayment({ commit, dispatch, state, getters }) {
        $('#pageLoadingModal').modal('show');
        commit('SET_PAGE', { loading: true });
        commit('SET_BOOKING_SUBMISSION', { loading: true, error: '', submitted: false });
        commit('SET_PAYMENT_INFO', { loading: true, error: '' });
        const PersonalDetails =  {
            Firstname: state.personalInfo.firstName,
            Lastname: state.personalInfo.lastName,
            emailAddress: state.personalInfo.email,
            phoneNumber: state.personalInfo.phone
        };

        var currentPortal = helper.getPortalName();
        //Customer number - payment API
        // var customerNumber = getters.GET_PAYMENT_API;
        // customerNumber = customerNumber.customerNumber;
        // Shallow Clone Selected Booking Products
        var selectedBookingProducts = JSON.parse(JSON.stringify(!getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED ? state.bookingState.selectedBookingProducts : state.activeMultipleServiceSelectedBookingProducts))
        
        // Ommit any services
        var serviceProduct = !getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED ? selectedBookingProducts.find(product => product.isService) : false;
        if(serviceProduct){
            selectedBookingProducts = selectedBookingProducts.filter(product => !product.isService)
            if(selectedBookingProducts.length > 0)
            selectedBookingProducts[0].price += (serviceProduct.price * serviceProduct.qty) 
        } else {
            // Include service fees to first waste stream of that service
            const servicePrices = new ServicePrices();
            let l = [];
            Object.entries(helper.objectsGroupBy(selectedBookingProducts, 'service_setting_id')).forEach(service => {
                const [service_setting_id, products] = service;
                if (servicePrices.groupById[service_setting_id] && servicePrices.groupById[service_setting_id].length > 0) {
                    // has price setup
                    // Add service charge to first product pricing
                    products[0].price += servicePrices.groupById[service_setting_id][0].price;
                }

                l = l.concat(products);
            });

            // Re-assign producs
            selectedBookingProducts = l;
        }
        
        selectedBookingProducts = selectedBookingProducts.map((product) => {
            const p = { ...product };
            const subPrice = helper.computeProductPrice(p, state.getDefaultData.gst_setting_percent);
            p.price = parseInt(`${subPrice}`.replace('.', ''));
            return p;
        });
        // const SelectedProducts = []

        const Amount = parseInt(state.bookingSummaryDetails.totalAmount.replace('.', ''));
        const bookingSubmission =  state.bookingSubmission
        const workOrder = bookingSubmission.form
        const CRN1 = workOrder.crn;

        var serverDate = getters.GET_SERVER_DATE ? getters.GET_SERVER_DATE.payload : null;
        const currDate = new DateNoTz(serverDate).asJsDate();

        var collectionDate = workOrder.collectionDate
        var PreparationNote = `Your waste will be collected between <br>Monday to Friday</b> of your chosen week. Please place your waste out for collection on <br>${state.bookingState.collectionData.preparationDate}</b> before your collection week.`;
        
        const body = { 
            date: currDate.getFullYear() + '-' + ('0' + (currDate.getMonth()+1)).slice(-2) + '-' + ('0' + currDate.getDate()).slice(-2) + ' ' + ('0' + currDate.getHours()).slice(-2) + ":" + ('0' + currDate.getMinutes()).slice(-2) + ":" + ('0' + currDate.getSeconds()).slice(-2),
            CardDetails: {
                CardHolderName: state.paymentInfo.name,
                CardNumber: state.paymentInfo.number,
                Cvn: state.paymentInfo.cvn,
                ExpiryDate: state.paymentInfo.expiryMonth + '' + state.paymentInfo.expiryYear
            },
            PersonalDetails,
            Address: { ...state.bookingState.activeAddress },
            SelectedProducts : selectedBookingProducts,
            Amount,
            CRN1,
            PortalName : currentPortal,
            
            // 2020-12-10 optional fields (Not currently used in BE payment submission to BPoint as confirmed with Shan) - Joseph
            PickupDate: (state.activeServiceSetting && state.activeServiceSetting.is_generate_pickup_date === helper.Option.On) ? (state.bookingState.collectionData.pickupDate || 'N/A') : 'N/A',
            CollectionDate: collectionDate ? collectionDate : new Date(),
            PreparationNote: PreparationNote,
            PreparationDate: state.bookingState.collectionData ? state.bookingState.collectionData.preparationDate : "N/A"
        };

        axios.post(process.env.MIX_API_URL + 'bpoint-auth', body)
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if(serviceProduct) data.serviceProduct = serviceProduct
                commit('SET_PAYMENT_INFO', { loading: false });
                dispatch('submitWorkOrderForm', data || null);
            })
            .catch(e => {
                // alert('Something went wrong. Please try again.');
                var statusCode = e.response ? e.response.status : 773
                commit('SET_PAGE', { loading: false });
                commit('SET_PAYMENT_INFO', { 
                    loading: false, 
                    error: helper.errorCatch(e) || 'Error in payment', 
                    valid: false, 
                    statusCode : statusCode
                });
                commit('SET_BOOKING_SUBMISSION', { loading: false, error: helper.errorCatch(e) || 'Error in payment', statusCode : statusCode });
                $('#pageLoadingModal').modal('hide');
            });
    },
    formSteps({ commit }) {
        commit('SET_FORM_STEPS', data);
    },
    activeFormIndex({ commit }, data) {
        commit('SET_ACTIVEFORM_INDEX', data);
    },
    setAcknowledge({ commit }, data) {
        commit('SET_BOOKING_ACKNOWLEDGE', data);
    },
    setPaymentInfo({ commit, dispatch }, data) {
        if (data) {
            commit('SET_PAYMENT_INFO', data);
            if (data.valid) {
                dispatch('workOrderCheck', 'submitPayment');
            } else {
                dispatch('setSubmission', { loading: false });
            }
        } else {
            commit('SET_PAYMENT_INFO', {
                loading: false,
                error: null,
                name: null,
                number: null,
                expiryMonth: null,
                expiryYear: null,
                cvn: null,
                valid: false
            });
        }
    },
    getWasteCombo({ commit, state }) {
        commit('SET_WASTE_COMBO', { loading: true, fetched: false, error: '', list: [] });
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/get-waste-stream-combo-by-service/' + state.bookingState.selectedService.service_setting_id)
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                // Make sure that both primary and secondary ID exists
                const list = data.list.filter(d => d.primary_waste_stream && d.secondary_waste_stream).map(d => {
                    return {
                        api_value: d.api_value,
                        primary_waste_stream_setting_id: d.primary_waste_stream.waste_stream_setting_id,
                        secondary_waste_stream_setting_id: d.secondary_waste_stream.waste_stream_setting_id,
                    }
                });
                commit('SET_WASTE_COMBO', { loading: false, fetched: true, list });
            })
            .catch(e => {
                commit('SET_WASTE_COMBO', { loading: false, error: helper.errorCatch(e) || 'Error fetching waste stream combo' });
            });
    },
    getWasteComboList({ commit, state }) {
        return axios.get(process.env.MIX_API_URL + 'cms/booking-setting/get-waste-stream-combo/')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                commit('SET_WASTE_COMBO_LIST', data);
                return data
            })
            .catch(() => console.log('Error when get waste stream combo from api'));
    },
    getComputedEntitlements({ }, payload) {
        return axios.post(process.env.MIX_API_URL + 'compute-entitlement', payload)
            .then(response => new ResponseDataExtractor(response).data)
            .catch(() => console.log('Error when compute entitlement from api'));
    },
    setMaxStreamPrice({commit}, data){
        commit('SET_MAX_STREAM_PRICE', data);
    },
    setIsCollectionWeekShown({commit}, data){
        commit('SET_IS_COLLECTION_WEEK_SHOWN', data);
    },
    getServiceGroupWording({ commit }) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/group-service-wordings')
        .then(response => new ResponseDataExtractor(response).data)
        .then(data => {
            if(data && Array.isArray(data.list) && data.list.length > 0){
                commit('SET_SERVICE_GROUP_WORDING', data.list);
            }
        })
        .catch(() => console.log('Error when get group service wording from api'));
    },
    setActiveMultipleCollectionSetting({ commit }, data) {
        commit('SET_ACTIVE_MULTIPLE_COLLECTION_SETTING', data);
    },
    getAddressCollectionWeek({ }, id) {
        return axios.get(process.env.MIX_API_URL + 'collection-week-schedule?id=' + id)
        .then(response => new ResponseDataExtractor(response).data)
        .then(data => {
            /*
                Stry: Adjustment_027 - do not display bins with 0 qty
                Date: 2021-03-08
                Auth: Franco Mapua
                Desc: 
                current checking if bin size is blank - do not display.
                Add condition:
                if bin size is blank
                OR
                qty = 0 
            */
            if (
                data &&
                Array.isArray(data.nextCollectionDates)
            ) {
                data.nextCollectionDates = data.nextCollectionDates.filter(
                    ({ binQuantity, binSize }) => {
                        if (
                            !binQuantity ||
                            isNaN(binQuantity) ||
                            binQuantity <= 0
                        ) {
                            return false
                        } else if (
                            !binSize ||
                            typeof binSize != "string" ||
                            binSize.trim().length == 0
                        ) {
                            return false
                        }
                        else{
                            return true
                        }
                    }
                );
            }

            return data
        })
        .catch(() => console.log('Error when get collection week schedule from api'));
    },
    getSearchInstructionSettings({commit}) {
        axios.get(process.env.MIX_API_URL + 'cms/ui-setting/search-instruction')
        .then(response => new ResponseDataExtractor(response).data)
        .then(data => {
            if(data && Array.isArray(data.list) && data.list.length > 0){
                commit('SET_SEARCH_INSTRUCTION_SETTINGS', data.list[0]);
            }
        })
        .catch(() => console.log('Error when get search instruction from api'));
    },
    getAdditionalQuestions({ commit }) {
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/additional-question')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if(data && Array.isArray(data.list) && data.list.length > 0){
                    commit('SET_ADDITIONAL_QUESTIONS', data.list);
                }
            })
            .catch(() => console.log('Error when get group service wording from api'));
    }
}